<template>
  <div class="rounded-xl bg-white shadow-md">
    <div
      class="flex align-center justify-between px-5 md:px-10 py-5 pb-7 flex-row text-center md:text-left items-center"
    >
      <div>
        <h1
          class="text-4xl font-normal mb-5 block"
          data-test="welcome-message"
        >
          Welcome back!
        </h1>
        <p
          class="mb-3"
          v-if="companyAdminStore.company && companyAdminStore.statistics"
          data-test="statistics"
        >
          Since {{ new Date(companyAdminStore.company?.enteredDate).getFullYear() }}, your
          <strong>{{ companyAdminStore.statistics?.total_employees }}</strong> employees have made
          <strong>{{ companyAdminStore.statistics?.total_donations }}</strong> donations totaling
          <strong> {{ filters.formatMoney(companyAdminStore.statistics?.total_amount) }} </strong>, and their generosity
          has impacted <strong>{{ companyAdminStore.statistics?.total_causes }}</strong> different causes!
        </p>
        <p v-else>
          <Skeleton
            height="1rem"
            class="mb-2 w-full"
            data-test="skeleton"
          />
          <Skeleton
            height="1rem"
            class="mb-2 w-full"
            data-test="skeleton"
          />
        </p>
        <p>Thank you for your support!</p>
      </div>
      <div v-if="!isMobile && companyAdminStore.company && companyAdminStore.statistics">
        <!-- <HeartBox :fill="donorStore.mainColor" /> -->
        <img
          v-if="companyAdminStore.company.logo"
          class="w-[80] ml-4"
          :src="companyAdminStore.company.logo"
          alt="company-logo"
          data-test="company-logo"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import filters from '@/helpers/filters';
import HeartBox from '@/assets/HeartBox.vue';
import useIsMobile from '@/composables/useIsMobile.js';
const { isMobile } = useIsMobile();

const companyAdminStore = useCompanyAdminStore();
</script>
